import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatus } from '@typings/common';
import { QrCodeState } from '@store/qr-code/types';
import { fetchQrRegisterAction, clearQrRegisterAction } from '@store/qr-code/actions';

const initialState: QrCodeState = {
    qrRegistered: undefined,
    status: LoadingStatus.Idle,
    error: null,
};

export const qrCodeReducer = createReducer(initialState, (builder) => {
    builder.addCase(clearQrRegisterAction, (state) => {
        state.status = initialState.status;
        state.qrRegistered = initialState.qrRegistered;
        state.error = initialState.error;
    });
    builder.addCase(fetchQrRegisterAction.pending, (state) => {
        state.status = LoadingStatus.Loading;
        state.qrRegistered = initialState.qrRegistered;
    });
    builder.addCase(fetchQrRegisterAction.fulfilled, (state, action) => {
        state.status = LoadingStatus.Success;
        state.qrRegistered = action.payload;
    });
    builder.addCase(fetchQrRegisterAction.rejected, (state, action) => {
        state.status = LoadingStatus.Failure;
        state.error = action.payload;
    });
});
